import axios from "axios";

export const makeDefaultAxiosInstance = ({ baseURL }: { baseURL?: string }) => {
  const instance = axios.create({
    baseURL,
  });

  return instance;
};
